import { ValidationErrors } from '@angular/forms';
import { createAction, props } from '@ngrx/store';

export const SetSchedulerErrors = createAction(
  '[Scheduler] Set Scheduler Errors',
  props<{ errors: ValidationErrors | null }>()
)

export const SetSchedulerPrintView = createAction(
  '[Scheduler] Set Scheduler PrintView',
  props<{ printView: boolean }>()
)

export const SetShowConsolidatedAppointments = createAction(
  '[Scheduler] Set ShowConsolidatedAppointments',
  props<{ showConsolidatedAppointments: boolean }>()
)

export const SchedulerAppointmentsBound = createAction('[Scheduler] Appointments Bound')
